import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsCompletedMocks: MicroMoments = {
  id: '',
  title: 'You completed your MQMs!',
  description:
    'You’re done with your Flight Qualifier, you just need to complete a Spend Qualifier.',
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/completed.gif',
    alt: 'Completed Travel Logo'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
